import { useConfig } from "../state";
export const Logo = () => {
  const config = useConfig();
  const h = config.site.prefix === "ba" ? 6 : 12;
  return (
    <div>
      <span className="sr-only">{config.site.title}</span>
      <img className={`h-${h} w-auto`} src={config.logo} alt={config.site.title} />
    </div>
  );
};
